import {rpc} from './session';

export async function getGuestToken() {
    return await rpc.request('com.rnis.auth.action.login_as_guest');
}


// WEBPACK FOOTER //
// ./src/helpers/api/auth.js